import script from "./StrategyView.vue?vue&type=script&setup=true&lang=js"
export * from "./StrategyView.vue?vue&type=script&setup=true&lang=js"

import "./StrategyView.vue?vue&type=style&index=0&id=72bdbe3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72bdbe3c"]])

export default __exports__